export default __webpack_public_path__ + "b4c425e21d0f4655d1ebd4fdccbf070a.png";